import { Box } from "@mui/material"

export const X = ({ color, width = 24, height = 24 }) => {
    return (
        <Box
            component="svg"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12.734 12.734"
            sx={{
                color: color || "#a18168",
            }}
            className="transition-colors"
        >
            <line
                x1="12.609" y1="12.609" x2=".125" y2=".125"
                stroke={"currentColor"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1px"
            />
            <line
                x1="12.609" y1=".125" x2=".125" y2="12.609"
                stroke={"currentColor"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1px"
            />
        </Box>
    )
}